export var MultipleEmailsDirective = [
    function () {
        return {
            link: function ($scope, $element, $attributes, $ctrl) {
                var $ngModelCtrl = $ctrl;
                var defaultEmailValidation = $ngModelCtrl.$validators.email;
                var isEmpty = $ngModelCtrl.$isEmpty;
                var isValid = function (arg) {
                    var emails = arg.split(/[\s;,]/).filter(function (s) { return s !== ''; });
                    return emails.every(function (email) { return defaultEmailValidation(email, email); });
                };
                if (typeof defaultEmailValidation === 'undefined') {
                    console.warn('<ngModelCtrl>.$validators.email is not defined for element: ' + $element);
                    return;
                }
                if ($element.prop('tagName') !== 'INPUT' || $element.attr('type') !== 'email') {
                    console.warn('Form element should be <input type="email">. Element: ' + $element);
                    return;
                }
                if ($element.attr('multiple') !== 'multiple')
                    $element.attr('multiple', 'multiple');
                $ngModelCtrl.$validators.email = function (modelValue, viewValue) {
                    var value = modelValue || viewValue;
                    return isEmpty(value) || isValid(value);
                };
            },
            require: 'ngModel',
            restrict: 'A',
        };
    },
];
